module.exports = __webpack_public_path__ + "static/don4-ba22cb109d8e87d089847522e767a775.jpg";